import { useEffect, useState } from 'react';
import { buildAvailability, EMPTY_AVAILABILITY } from './turnaround';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Fetches the availability for a trailer and returns
//   { bookedDateStrings, checkInDays, turnaroundDays }
// bookedDateStrings is the Set of YMD strings `<DateTimePicker
// bookedDateStrings={...}>` expects (days to grey out); checkInDays and
// turnaroundDays feed checkOutConstraints() so the check-out picker can
// allow same-day turnover. See booking/turnaround.js.
//
// Returns empty sets while loading / on error, so callers can pass the
// values to the pickers without null checks.
export default function useBookedDates(trailerId) {
  const [availability, setAvailability] = useState(EMPTY_AVAILABILITY);

  useEffect(() => {
    if (!trailerId) return;
    let cancelled = false;
    fetch(`${API_URL}/api/trailers/${trailerId}/availability`)
      .then((r) => r.json())
      .then((data) => {
        if (cancelled || !data?.success) return;
        setAvailability(buildAvailability(data));
      })
      .catch(() => { /* network errors leave the sets empty */ });
    return () => { cancelled = true; };
  }, [trailerId]);

  return availability;
}
